export const ratesQuery = `{
  rates {
    id
    value
  }
}`
